import { useState } from "react";
import { motion } from "motion/react";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_16e04e72-902a-4ec2-915f-9027a566527c/artifacts/zlzlzxe9_logo%20BHG%20preferido%20fondo%20transparente%20HR.webp";

const NAV_LINKS = [
  { label: "Inicio", href: "#inicio" },
  { label: "Método", href: "#metodo" },
  { label: "Proyectos", href: "#proyectos" },
  { label: "Servicios", href: "#servicios" },
  { label: "Ecosistema", href: "#ecosistema" },
  { label: "Participa", href: "#participa" },
  { label: "Contacto", href: "#contacto" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="fixed top-4 left-4 right-4 z-50 mx-auto max-w-6xl"
      data-testid="main-navbar"
    >
      <nav className="liquid-glass rounded-full px-5 md:px-8 py-3 flex items-center justify-between bg-black/30">
        <a href="#inicio" className="flex items-center gap-3" data-testid="navbar-logo-link">
          <img src={LOGO_URL} alt="BHG · Barinas Heritage Global" className="h-10 w-auto" />
          <span className="hidden sm:block text-[#C6A15B] font-serif-display text-lg font-semibold tracking-wide">
            BHG
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
                className="text-xs uppercase tracking-widest text-white/70 hover:text-[#C6A15B] transition-colors"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href="#contacto"
            data-testid="navbar-cta-conversemos"
            className="hidden sm:inline-flex items-center rounded-full bg-[#C6A15B] px-5 py-2 text-xs uppercase tracking-widest text-black font-medium hover:bg-[#d9b876] transition-colors"
          >
            Conversemos
          </a>
          <button
            onClick={() => setOpen(!open)}
            data-testid="navbar-mobile-toggle"
            className="lg:hidden text-white/80 hover:text-white transition-colors p-1"
            aria-label="Abrir menú"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </nav>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          className="lg:hidden liquid-glass rounded-3xl mt-2 p-6 bg-black/60"
          data-testid="navbar-mobile-menu"
        >
          <ul className="flex flex-col gap-4">
            {NAV_LINKS.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="text-sm uppercase tracking-widest text-white/80 hover:text-[#C6A15B] transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#contacto"
                onClick={() => setOpen(false)}
                className="inline-flex items-center rounded-full bg-[#C6A15B] px-5 py-2 text-xs uppercase tracking-widest text-black font-medium"
              >
                Conversemos
              </a>
            </li>
          </ul>
        </motion.div>
      )}
    </motion.header>
  );
};
